export const version = "1776784702";
export const env = "production";
export const flavor = "CashPoint";

export const stripeKeys = {
  AU: "pk_live_51PYzGJDUDDYvYAi6qEeuM7roC5qkWwukuppk0qZurW2Os9mYfqGyIXYEKsUl3TtagYNBGZruVcQrmO0rufzwMQ4D00B11W6sKY",
  SG: "",
  JP: "",
};

export const stripeSubKeyIntentions = {
  AU: 1,
  SG: 3,
  JP: 5,
};

export const stripeKey =
  "pk_live_51PYzGJDUDDYvYAi6qEeuM7roC5qkWwukuppk0qZurW2Os9mYfqGyIXYEKsUl3TtagYNBGZruVcQrmO0rufzwMQ4D00B11W6sKY";
export const defaultStripeRegion = "AU";
export const stripeClientId = "ca_JIDdhTMwhkzf216fd73pP4cUQEablwmO";
export const stripeSGClientId = "";
export const ubereatsClientId = "ko3MAcXQ8AM4Fqx1LyVCSGV7U0gJjb_S"; // 改为cashpoint

export const cloudImageBaseUrl = "https://res.myposzero.com.au/";
export const tyroClientId = "";

export const appName = 'MyPOS'

export const xeroConnectUrl = 'https://login.xero.com/identity/connect/authorize?response_type=code';
export const xeroConnectRedirectUrl = 'https://portal.myposzero.com.au/integration/xero-redirect'

export const innerSuperAdmins = [-2];